export default "__VITE_ASSET__DVDfN33n__"